import React, { useEffect, useState } from 'react';
import { aaiApi } from '../../services/aaiApi';
import type { DepartmentAggregate } from '../../types/aai';
import { AggregateView, ErrorNote, Loading } from './components';

// A DEPARTMENT_HEAD's own-department rollup (pinned server-side to their
// department — R1: rollup only, never individual coaching detail).
const DepartmentTab: React.FC<{ department: string | null }> = ({ department }) => {
  const [agg, setAgg] = useState<DepartmentAggregate | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!department) {
      setLoading(false);
      return;
    }
    (async () => {
      try {
        const res = await aaiApi.getDepartmentRollup(department);
        setAgg(res.data);
      } catch {
        setError('Could not load your department rollup.');
      } finally {
        setLoading(false);
      }
    })();
  }, [department]);

  if (!department) return <p className="text-sm text-gray-500">No department is assigned to you yet.</p>;
  if (loading) return <Loading label="Loading your department…" />;
  if (error) return <ErrorNote message={error} />;

  return (
    <div className="space-y-4">
      <p className="text-sm text-gray-500">
        Team rollup for <span className="font-medium text-gray-700">{department}</span> — aggregates only,
        to keep individual readiness private.
      </p>
      <AggregateView title={department} agg={agg} />
    </div>
  );
};

export default DepartmentTab;
